module.exports = __webpack_public_path__ + "static/media/dumbbell.7265d5bf.jpg";